import React, { useState, Fragment, useEffect } from 'react';
import axios from 'axios'
import moment from 'moment';

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { GridAutoTextField } from './helper/GridComponents';

import styles from "./styles";
import PageHeader from "./helper/PageHeader";
import SimpleTable from "./helper/SimpleTable";
import { useHistory } from 'react-router';
import { languageSearch, types } from '../constants/global'



const classFormat = [
    {
        value: '-1',
        label: 'All',
    },
    {
        value: '0',
        label: 'In Person',
    },
    {
        value: '1',
        label: 'Remote',
    }
];

const Workshops = props => {
    // values are not really related so not using a reducer
    const [formData, setFormData] = useState({
        //workshops: [],
        fromDate: moment().subtract(0, 'months').format("YYYY-MM-DD"),
        language: -1,
        type: 1,
        classFormat: -1,
        county: null,

        //error: null,
        //id: null,
        //isLoading: true
    })

    const [workshops, setWorkshops] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [counties, setCounties] = useState([]);
    const [formError, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    const hideError = () => {
        setError('')
    }

    const handleChange = event => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    }

    // const onChange = event => {
    //     setFormData({
    //         ...formData,
    //         [event.target.name]: event.target.value
    //     });
    // }

    // const onSelectChange = (event) => {
    //     setFormData({ ...formData, [event.target.name]: event.target.value });
    // }

    const onRegister = (url) => {
        window.open(url, "_blank");
    }

    const onWorkshopClick = (tag) => {
        let workshopID = tag;
        history.push({
            pathname: '/class/' + workshopID
        });
    }

    const onSearch = (event) => {
        refresh();
    }

    const refresh = () => {

        let date = moment( formData.fromDate );
        console.log('date validity', date.isValid() )
        
        if (date.isValid()){

            setIsLoading(true)
            axios.get('/api/workshop/search', {
                params: {
                    fromDate: formData.fromDate,
                    language: formData.language,
                    type: formData.type,
                    classFormat: formData.classFormat,
                    locCounty: formData.county && formData.county.value,
                    status: 1 // only published class
                }
            }).then((res) => {
                // console.log(res.data);
                let enhancedData = [];
                enhancedData = res.data.workshops.map((arrayItem) => {
                    let item = JSON.parse(JSON.stringify(arrayItem))
                    item.date = moment(item.fromDate).format('ddd MM-DD-YYYY');
                    item.organization = organizations[item.organizationId];
                    item.location = item.isRemote ? "Live Online Session" : item.location;
                    item.actionsDisabled = {
                        view: false,
                        register: !item.regExtUrl
                    }
                    return item;
                });
                setWorkshops(enhancedData);
                // setWorkshops(res.data.workshops)
                setIsLoading(false);
                
            }).catch(error => {
                //console.log("error:" + error);
                setError(error.message)
                setIsLoading(false)
            });

        }
        else{
            setError("From Date is InValid")

        }


       

    }
    // on mount call refresh
    useEffect(() => {
        axios.all([
            axios.get('/api/organization'),
            axios.get('/api/stateCounty/county/FL'),
        ]).then((res) => {
            res[0].data.organizations.forEach((u) => {
                organizations[u.ID] = u.organizationName;
            });
            res[1].data.forEach((u) => {
                counties.push({ label: u.stateCountyName, value: u.stateCountyName });
            });

            console.log(organizations);
            console.log(counties);
            refresh();
        });
    },[])

    const { classes } = props;

    // if (formError) {
    //     return <div>
    //         <br />
    //         <Alert severity="error" onClose={hideError}>{formError}</Alert>
    //         <br />
    //     </div>
    // }

    // if (formError !== null) return <Error />;

    const tableCells = [
        { id: 'language', label: 'Language', centered: false },
        { id: 'date', label: 'Date', centered: false },
        { id: 'location', label: 'Location', centered: false },
        { id: 'organization', label: 'Organization', centered: false }
    ];

    const actionButtons = [
        { icon: "view", action: onWorkshopClick, delete: false },
        { icon: "register", action: onRegister, attribute: "regExtUrl", delete: false },
    ];

    return (
        <Fragment>
            {
                formError 
                ?
                <Alert severity="error" onClose={hideError}>{formError}</Alert>
                :
                <></> 
            }
            <PageHeader
                title={"Statewide Training Schedule"}
                cancel={history.goBack}
            />

            <div>
                <div className={classes.root}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="fromDate"
                                label="From"
                                type="date"
                                name='fromDate'
                                value={formData.fromDate}
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="language"
                                name="language"
                                className={[classes.textField].join(' ')}
                                value={formData.language}
                                onChange={handleChange}
                                select
                                fullWidth
                                label="Language"
                            >
                                {languageSearch.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                id="type"
                                name="type"
                                className={[classes.textField].join(' ')}
                                value={formData.type}
                                onChange={handleChange}
                                select
                                fullWidth
                                label="Public/Private"
                            >
                                {types.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                         <Grid item xs={12} md={4}>
                            <TextField
                                id="classFormat"
                                name="classFormat"
                                className={[classes.textField].join(' ')}
                                value={formData.classFormat}
                                onChange={handleChange}
                                select
                                fullWidth
                                label="In person/Remote"
                            >
                                {classFormat.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                         <GridAutoTextField
                                getOptionSelected={(option, val) => option.value === val.value}
                                xs={12}
                                md={4}
                                name="county"
                                options={counties}
                                value={formData.county}
                                onChange={handleChange}
                                classes={classes}
                                label="Location County"
                            />
                        <Grid item xs={12}  md={4} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button variant="contained" color="primary" type="submit" className={[].join(' ')} onClick={onSearch} >Search</Button>
                        </Grid>
                    </Grid>

                    <br />
                    {isLoading &&
                        <h1>Please wait – search in process</h1>
                    }

                    {!isLoading &&
                    <Fragment>
                        <p>Found {workshops.length} records</p>
                        <br />

                        {workshops.length === 0
                            ?
                            <Box display="flex" mt={4} justifyContent="center">
                                <h1>No Data</h1>
                            </Box>
                            :
                            <SimpleTable
                                data={workshops}
                                cellKey={"ID"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={true}
                            />
                        }
                        </Fragment>
                    }
                </div>
            </div>
        </Fragment>
    );
}


// export default Workshops;
export default withStyles(styles, { withTheme: true })(Workshops);